import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadCRMLinkSession } from '../../actions/crmLink';
import { newRequestGuard } from '../../utils/crmLink';
import { contextFromSession } from '../../utils/crmContext';
import CrmContextBanner from './CrmContextBanner';

// The context banner for a page that knows only the session ID (MS-6626): the unit list a link
// landed on carries `?crm_link=<id>` and nothing else about the buyer, so the session is read here,
// the same way the continue page and the booking form read it, and rendered through
// CrmContextBanner. Reading a session never consumes it; that happens on booking submit.
//
// Only the newest read may act (newRequestGuard, whose rule and tests live with it): the list can
// move from one link to another, or unmount, while a read is in flight, and a late answer must not
// put a stranger's buyer on the screen. The screen is also cleared the moment a new read starts,
// for the same reason from the other side: the previous buyer must not stay up while the next one
// loads, on a tablet the next customer may already be looking at. A rejection — consumed, expired,
// somebody else's — shows nothing here: the page that needs to explain that is the one that acts
// on the session, and this one only describes it.
export class CrmLinkBanner extends Component {
  static propTypes = {
    linkID: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  }

  static defaultProps = {
    linkID: '',
  }

  state = { session: null };

  componentDidMount() {
    this.read(this.props.linkID);
  }

  componentDidUpdate(prev) {
    if (prev.linkID !== this.props.linkID) this.read(this.props.linkID);
  }

  componentWillUnmount() {
    this.guard.invalidate();
  }

  guard = newRequestGuard();

  read(id) {
    // Claim the guard first, so a read already in flight for a previous id can no longer land;
    // then clear what is showing, so nothing from the previous id stays up while this one loads.
    const token = this.guard.begin();
    if (this.state.session) this.setState({ session: null });
    if (!id) return;
    this.props.dispatch(loadCRMLinkSession(id)).then(({ session, rejection }) => {
      if (!this.guard.isCurrent(token)) return;
      this.setState({ session: rejection ? null : (session || null) });
    });
  }

  render() {
    return <CrmContextBanner context={contextFromSession(this.state.session)} />;
  }
}

export default connect()(CrmLinkBanner);



// WEBPACK FOOTER //
// ./src/components/Crm/CrmLinkBanner.jsx